import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';

import {Translate} from '../Translate';

import MDEditor from '@uiw/react-md-editor';
import {Link} from '@mui/material';
import {loadImages, parseImageURL} from 'utils/miscellaneous/image/image_url_processor';

const MarkdownViewer = (props) => {
  const [isTruncated, setIsTruncated] = React.useState(props.truncate);
  const [isOverflown, setIsOverflown] = React.useState(false);
  const [lineHeight, setLineHeight] = React.useState(24);

  const ref = React.useRef();

  const truncateLine = props.truncateLine || 6;

  React.useEffect(() => {
    const mdpCurrent = ref?.current?.mdp?.current;
    if (!mdpCurrent) {
      return;
    }
    const lineHeight = parseFloat(window
        .getComputedStyle(mdpCurrent, null)
        .getPropertyValue('line-height'), 10);
    setLineHeight(lineHeight);
  }, [ref]);

  React.useEffect(() => {
    const mdpCurrent = ref?.current?.mdp?.current;
    if (!mdpCurrent) {
      return;
    }
    const imageURLs = parseImageURL(mdpCurrent.innerHTML);

    loadImages(imageURLs).then((images) => {
      if (mdpCurrent.scrollHeight > (lineHeight * truncateLine)) {
        setIsOverflown(true);
      } else {
        setIsOverflown(false);
      }
    });
  }, [ref, lineHeight]);

  return (
    <Box sx={{'textAlign': 'left', 'wordWrap': 'break-word'}}>
      <MDEditor.Markdown
        ref={ref}
        style={
          isTruncated ?
           {
             lineHeight: '24px',
             maxHeight: `${truncateLine * lineHeight}px`,
             overflow: 'hidden',
             textOverflow: 'ellipsis',
           } :
          props.style
        }
        source={props.value}/>
      {
        (isTruncated && isOverflown) &&
        <Link
          onClick={(event) => {
            event.preventDefault();
            setIsTruncated(false);
          }}
          sx={{
            '&:hover': {
              cursor: 'pointer',
            },
          }}
        >
          <Translate expression='generic.ShowMore'/>
        </Link>
      }
    </Box>
  );
};

MarkdownViewer.propTypes = {
  value: PropTypes.string.isRequired,
  truncate: PropTypes.bool,
  style: PropTypes.object,
  truncateLine: PropTypes.number,
};

export default React.memo(MarkdownViewer);
